export function maskCNPJ(input) {
  if (!input) return ''
  const value = input.replace(/\D/g, '').substr(0, 14)
  return value
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/(\.\d{3})(\d)/g, '$1.$2')
    .replace(/(\.\d{3})(\d)/, '$1/$2')
    .replace(/(\/\d{4})(\d)/, '$1-$2')
}
